import { cn } from '@repo/ui/utils'

export function Muted({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <p className={cn('text-muted-foreground text-sm', className)}>{children}</p>
  )
}
